import React from 'react';
import bmwSrc from './checkmark.svg';
import miniSrc from './mini-btn-checkmark.svg';
import styles from './styles.module.scss';
import PropTypes from 'prop-types';

export const UnselectButton = ({ unselectTemplate, mini }) => {
  let src = mini ? miniSrc : bmwSrc;
  return (
    <button className={styles.button} onClick={unselectTemplate}>
      <img alt={'check mark'} src={src} />
    </button>
  );
};

UnselectButton.propTypes = {
  unselectTemplate: PropTypes.func.isRequired,
};

export default UnselectButton;
